import { render, staticRenderFns } from "./RegistrationBase.vue?vue&type=template&id=1018313c&"
import script from "./RegistrationBase.vue?vue&type=script&lang=js&"
export * from "./RegistrationBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports